<template>
  <div>
    <a-page-header title="Users">
      <template slot="extra">
        <a-button key="1" type="primary" @click="addNewUser()"
          >Add New User
        </a-button>
      </template>
    </a-page-header>
    <data-table
      ref="usersDataTable"
      :columns="columns"
      :data-source="usersState.users"
      :loading="loading"
      @refreshData="fetchData"
      rowKey="id"
      :totalCount="usersState.usersCount"
    >
      <span slot="isActive" slot-scope="record">
        <a-tag :color="record.isActive ? 'green' : 'volcano'">
          {{ (record.isActive ? "ACTIVE" : "DISABLED").toUpperCase() }}
        </a-tag>
      </span>

      <date-time-column
        slot="creationDate"
        slot-scope="record"
        v-model="record.creationDate"
      />

      <span slot="action" slot-scope="record">
        <a class="edit-icon" @click="showEditModal(record.id)">
          <a-icon type="edit" />
        </a>
        <a-divider type="vertical" />
        <a class="trash-icon" @click="confirmDelete(record.id)">
          <a-icon type="delete" />
        </a>
      </span>
    </data-table>
    <EditUserModal
      v-model="isEditUserModalVisible"
      :user="editedUser"
      :businesses="businesses"
    ></EditUserModal>
    <NewUserModal
      v-model="isNewUserModalVisible"
      :user="newUser"
      :businesses="businesses"
    ></NewUserModal>
  </div>
</template>

<script>
import { usersState, usersMutations } from "../../Store/store";
import { businessState, businessMutations } from "../../Store/store";
import EditUserModal from "./EditUserModal";
import NewUserModal from "./NewUserModal";

const columns = [
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
    sorter: true,
    width: 200,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sorter: true,
    width: 250,
  },
  {
    title: "Business Name",
    dataIndex: "businessName",
    key: "businessName",
    sorter: true,
    width: 250,
  },
  {
    title: "Is Active",
    key: "isActive",
    sorter: true,
    scopedSlots: { customRender: "isActive" },
  },
  {
    title: "Creation Date",
    key: "creationDate",
    sorter: true,
    scopedSlots: { customRender: "creationDate" },
  },
  {
    title: "Actions",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 70,
  },
];

export default {
  data() {
    return {
      columns,
      isEditUserModalVisible: false,
      isNewUserModalVisible: false,
      businesses: [],
      editedUser: {},
      newUser: {},
      usersState: usersState,
      loading: false,
    };
  },
  async mounted() {
    await this.fetchData();
    await this.fetchBusinesses();
  },
  methods: {
    async fetchData(params = {}) {
      this.loading = true;

      try {
        await usersMutations.getUsers(params);
      } finally {
        this.loading = false;
      }
    },
    async fetchBusinesses() {
      await businessMutations.setBusinesses();
      this.businesses = businessState.businesses;
    },
    confirmDelete(userId) {
      const self = this;
      this.$confirm({
        title: "Please beware!",
        content: "Are you sure about deleting this user?",
        okText: "Delete",
        okType: "danger",
        maskClosable: true,
        cancelText: "Cancel",
        async onOk() {
          const user = self.usersState.users.find((u) => u.id === userId);

          if (user) {
            try {
              await usersMutations.deleteUser(user);
              self.$refs.usersDataTable.refreshData(true);
            } catch (error) {
              self.showError(error);
            }
          }
        },
      });
    },
    addNewUser() {
      this.newUser = {};
      this.isNewUserModalVisible = true;
    },
    showEditModal(userId) {
      this.editedUser = {
        ...this.usersState.users.find((i) => i.id == userId),
      };
      this.isEditUserModalVisible = true;
    },
  },
  components: {
    EditUserModal,
    NewUserModal,
  },
};
</script>

<style scoped>
.trash-icon:hover {
  color: #bb2020;
}
.edit-icon:hover {
  color: #121317;
}
</style>
